import { render } from "./UkrainianPayments.vue?vue&type=template&id=6254b73b"
import script from "./UkrainianPayments.vue?vue&type=script&lang=js"
export * from "./UkrainianPayments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__